import { z } from "zod";


export const GedDocumentoSchema = z.object({
  arquivo: z.string({ required_error: 'Este campo é obrigatorio!' }).nonempty('Este campo é obrigatorio!'),
  observacoes: z.string().nullable().default(null).optional(),
  file: z.instanceof(File).nullable().default(null),
  filePdf: z.instanceof(File).nullable().default(null),
  limparArquivo: z.coerce.boolean().default(false),
  limparArquivoPdf: z.coerce.boolean().default(false),
});


export type GedDocumentoForm = z.infer<typeof GedDocumentoSchema>;